import { Text } from "@repo/ui";
import React from "react";

type HeroTitleProps = {
	children: string | (string | React.ReactNode)[];
};

export const HeroTitle: React.FC<HeroTitleProps> = ({ children }) => {
	return (
		<Text
			align="center"
			style={{
				fontWeight: 650,
				maxWidth: 800,
				fontSize: 58,
				lineHeight: "58px",
				letterSpacing: "-0.03em",
			}}
			mobile={{
				style: {
					fontSize: 36,
					lineHeight: "40px",
				},
			}}
		>
			{children}
		</Text>
	);
};

type HeroSubtitleProps = {
	children: string | (string | React.ReactNode)[];
};

export const HeroSubtitle: React.FC<HeroSubtitleProps> = ({ children }) => {
	return (
		<Text
			size="xl"
			align="center"
			style={{ maxWidth: "min(720px, 80vw)", fontWeight: 450 }}
			balance
			mobile={{ size: "lg" }}
		>
			{children}
		</Text>
	);
};

type CallOutSectionTextProps = {
	children: string | (string | React.ReactNode)[];
	fancy?: boolean;
};

export const CallOutSectionText: React.FC<CallOutSectionTextProps> = ({
	children,
	fancy,
}) => {
	return (
		<Text
			italic={fancy}
			font={fancy ? "Newsreader" : undefined}
			color="sand12"
			style={{
				maxWidth: 560,
				fontSize: 40,
				lineHeight: "42px",
				letterSpacing: "-0.005em",
				fontWeight: 500,
			}}
		>
			{children}
		</Text>
	);
};

type SectionSubtitleProps = {
	children: string | (string | React.ReactNode)[];
};

export const SectionSubtitle: React.FC<SectionSubtitleProps> = ({
	children,
}) => {
	return (
		<Text
			as="p"
			align="center"
			light
			size="md"
			balance
			style={{ maxWidth: 800 }}
		>
			{children}
		</Text>
	);
};

type SectionTitleProps = {
	children: string;
};

export const SectionTitle: React.FC<SectionTitleProps> = ({ children }) => {
	return (
		<Text
			as="p"
			size="xxxl"
			weight="semibold"
			align="center"
			balance
			style={{ maxWidth: 640 }}
		>
			{children}
		</Text>
	);
};
